// Utils
import { propIn } from '../../../common/utils/immutableHelper';

export const getTempEditorState = propIn(['temp', 'editorState']);
export const getTempHidden = propIn(['temp', 'hidden']);
